import angular from "angular";

angular
    .module('app')
    .service('Notifier', ['notify', function (notify) {

        this.success = function (message, duration) {
            notify({
                messageTemplate: '<div>' + message + '</div>',
                classes: 'alert-success',
                duration: duration ? duration * 1000 : 0
            });
        };

        this.error = function (message, duration) {
            notify({
                messageTemplate: '<div>' + message + '</div>',
                classes: 'alert-danger',
                duration: duration ? duration * 1000 : 0
            });
        };

        this.closeAll = function () {
            notify.closeAll();
        };

    }]);
